import { watch, onMounted, onUnmounted } from 'vue';

const STYLE_ID = 'custom-cursor-style';

function getOrCreateStyleEl() {
  let el = document.getElementById(STYLE_ID);
  if (!el) {
    el = document.createElement('style');
    el.id = STYLE_ID;
    document.head.appendChild(el);
  }
  return el;
}

function removeStyleEl() {
  document.getElementById(STYLE_ID)?.remove();
}

function applyStyles(cursorType, isPreviewMode) {
  if (cursorType === 'DEFAULT') {
    removeStyleEl();
    document.body.style.cursor = 'auto';
    document.documentElement.style.removeProperty('cursor');
    return;
  }

  if (isPreviewMode) {
    // Hide native cursor only inside the portfolio preview, sidebar panel
    // (including any modals rendered as siblings of .ufo-sepa inside
    // .ufo-sepa--container) and the editor nav bar.
    getOrCreateStyleEl().innerHTML =
      `.ufo--portfolio-page, .ufo--portfolio-page *,
      .ufo-sepa--container, .ufo-sepa--container *,
      .ufo--nav-bar, .ufo--nav-bar * { cursor: none !important; }`;
    document.body.style.cursor = 'auto';
    document.documentElement.style.removeProperty('cursor');
  } else {
    // Live mode — hide native cursor everywhere
    getOrCreateStyleEl().innerHTML = `* { cursor: none !important; }`;
    document.body.style.cursor = 'none';
    document.documentElement.style.setProperty('cursor', 'none', 'important');
  }
}

/**
 * Composable that keeps `<style id="custom-cursor-style">` and
 * `document.body.style.cursor` in sync with the current cursor type
 * and preview mode. Automatically mounts/unmounts the style element.
 *
 * @param {import('vue').ComputedRef<string>}  cursorType
 * @param {import('vue').ComputedRef<boolean>} isPreviewMode
 */
export function useCursorStyleSync(cursorType, isPreviewMode) {
  onMounted(() => applyStyles(cursorType.value, isPreviewMode.value));

  onUnmounted(() => {
    removeStyleEl();
    document.body.style.cursor = 'auto';
    document.documentElement.style.removeProperty('cursor');
  });

  watch(cursorType,     (type)    => applyStyles(type, isPreviewMode.value));
  watch(isPreviewMode, (preview) => applyStyles(cursorType.value, preview));
}
